import { z } from 'zod';
import { networkCodes, SupportedChainId } from '@orionprotocol/sdk';

import { Feature } from '../../../types';

export const networkCodesEnum = z.enum(networkCodes);

const pureChainInfoSchema = z.object({
  chainId: z.nativeEnum(SupportedChainId),
  label: z.string(),
  code: networkCodesEnum,
  shortName: z.string(),
  explorer: z.string(),
  rpc: z.string(),
  baseCurrencyName: z.string(),
});
// const { pureEnvPayloadSchema } = config.schemas; // Extending doesn't work. Don't know why.
export const chainInfoSchema = pureChainInfoSchema.extend({
  description: z.array(z.string()).optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  disabledFeatures: z.array(z.nativeEnum(Feature)).optional(),
  isSwapAvailable: z.boolean().optional(),
  isGovernanceAvailable: z.boolean().optional(),
});

export const chainSchema = z.record(
  z.nativeEnum(SupportedChainId),
  chainInfoSchema,
);
